export default "__VITE_ASSET__BrePOg_w__"